<div class="dropdown filter-dropdown">
  <!-- Filter Icon -->
  <span
    class="icon-filter"
    id="filterDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  ></span>

  <!-- Dropdown Menu -->
  <ul class="dropdown-menu p-3" aria-labelledby="filterDropdown">
    <!-- Consumption Type Group -->
    <li>
      <strong>Consumption Type</strong>
      <div *ngFor="let option of consumptionOptions" class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="consumptionType"
          (change)="onCheckboxChange($event, option.value)"
          [checked]="selectedConsumptionTypes.includes(option.value)"
          [id]="option.id"
          [value]="option.value"
        />
        <label class="form-check-label" [for]="option.id">{{ option.label }}</label>
      </div>
    </li>
    <hr />
    <!-- View Type Group -->
    <li>
      <strong>View Type</strong>
      <div *ngFor="let option of viewTypeOptions" class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="viewType"
          (ngModelChange)="onViewTypeChange($event)"
          [(ngModel)]="selectedViewType"
          [id]="option.id"
          [value]="option.value"
        />
        <label class="form-check-label" [for]="option.id"> {{ option.label }} </label>
      </div>
    </li>
    <!-- <hr /> -->
    <!-- Additional Graphs -->
    <!-- <li>
      <strong>Additional graphs</strong>
      <ng-container *ngFor="let option of additionalGraphOptions">
        <div *ngIf="option.isVisible" class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              name="additionalGraph"
              (change)="onViewAdditionalGraph($event, option.value)"
              [id]="option.id"
            />
            <label class="form-check-label" [for]="option.id"> {{ option.label }} </label>
          </div>
      </ng-container>
    </li> -->
  </ul>
</div>
